import { DocumentState } from "../types";

const state: DocumentState = {
  country: "",
  countryCode: "",
  documentType: "",
  supportedDocuments: [],
};

export default state;
